// extracted by mini-css-extract-plugin
export default {"questionContiner":"SurveyPage_questionContiner__WUI3g"};